<template lang="pug">
.c-todos-content
  //- Teleport button to parent nav actions
  teleport(to="#resource-actions-portal" v-if="mounted")
    el-button(type="primary" @click="dialog=true")
      fai(type="fal" icon="plus-circle")
      span Add New

  //- Table Section
  section.c-todos-table-section
    el-table(
      :data="items.items"
      v-loading="loading"
      @row-click="$router.push(`todos/${$event.id}`);"
      style="width: 100%"
    ).clickable-rows
      el-table-column(width="15")
      el-table-column(label="Todo" prop="todo")
      el-table-column(label="Protip" prop="protip")
      el-table-column(width="46")
        template(#default)
          .el-table__expand-icon
            img(src="@/assets/icons/light/chevron-right-light.svg")
      el-table-column(width="15")

  DialogAddTodo(
    v-if="dialog"
    :loading="loading"
    v-model="dialog"
    @save-item="saveTodo($event)"
    @close-dialog="dialog = false"
  )
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted } from 'vue';
import DialogAddTodo from './DialogAddTodo.vue';
import shared from '../shared';

export default defineComponent({
  name: 'Todos',
  components: { DialogAddTodo },
  setup() {
    const {
      doFindTodos,
      doMutateTodo,
      loading,
      dialog,
    } = shared();
    const mounted = ref(false);
    const items = reactive({ items: [] });
    async function getItems() {
      try {
        loading.value = true;
        items.items = await doFindTodos();
      } catch (err) {
        console.log(err);
      } finally {
        loading.value = false;
      }
    }
    async function saveTodo(item: any) {
      await doMutateTodo(item);
      await getItems();
    }
    onMounted(async () => {
      await getItems();
      mounted.value = true;
    });
    return {
      mounted,
      items,
      loading,
      dialog,
      saveTodo,
    };
  },
});

</script>

<style lang="scss" scoped>
@import '@/views/manage-users-and-organizations/crm-list';

.c-todos-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@include crm-table('c-todos-table-section');

.c-todos-table-section :deep(.el-table__expand-icon) {
  display: flex;
  align-items: center;
  height: 20px;
}

.c-todos-table-section :deep(.clickable-rows .el-table__row:hover > td.el-table__cell) {
  background-color: rgba($muted, 0.5);
}
</style>
